import React from 'react';
import { createRoot } from 'react-dom/client';
import QuoteMaster   from './Static/QuoteMaster.js';
import { QuoteMasterContextProvider } from './Static/QuoteMasterContext.js';
import { StyledEngineProvider } from '@mui/material/styles';
import './global.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SocketContextProvider } from './Static/SocketContext.js';
import PasswordReset from './Static/PasswordReset/PasswordReset.js';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <StyledEngineProvider injectFirst>
        <QuoteMasterContextProvider>
            <SocketContextProvider>
                <BrowserRouter future={{ v7_relativeSplatPath: true,  v7_startTransition: true }}> 
                    <Routes>
                        <Route path="/password-reset" element={<PasswordReset />} />
                        <Route path="/" element={<QuoteMaster />} />
                    </Routes>
                </BrowserRouter>
            </SocketContextProvider>  
        </QuoteMasterContextProvider>
    </StyledEngineProvider>
);